import { Component, h, Prop, State, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

declare global {
  interface Window {
    MktoForms2: any;
  }
}

@Component({
  tag: 'cta-block-form',
  styleUrl: 'cta-block-form.css',
  shadow: false,
})
export class CtaBlockForm {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The supertitle
   */
  @Prop() supertitle: string;

  /**
   * subtitle
   */
  @Prop() subtitle: string;

  /**
   * Form ID
   */
  @Prop() formId: string;

  /**
   * Icon Rows
   */
  @Prop() iconRows: string;

  /**
   * Icon Rows Image Class
   */
  @Prop() imageClass: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }

  @Element() el: HTMLElement;

  @State() scriptLoaded: boolean = false;

  @State() formLoaded: boolean = false;

  componentWillLoad() {
    // Check if the form has already been loaded for this component
    if (this.formLoaded || !this.formId) {
      return;
    } else {
      //console.log(this.formLoaded);
      const script = document.createElement('script');
      script.src = '//saferworld.3eco.com/js/forms2/js/forms2.min.js';
      this.formLoaded = true;
      script.onload = () => {
        this.scriptLoaded = true;
        if (window.MktoForms2) {
          window.MktoForms2.loadForm('//saferworld.3eco.com', '026-BZE-703', parseInt(this.formId));
          this.loadHiddenFieldsScript();
        }
      };
      document.body.appendChild(script);
    }
  }

  componentDidLoad() {
    addIntersectionObserver(
      this.el.querySelector('.cta-form-section'),
      () => {
        this.el.querySelector('.cta-form-section').classList.add('animate');
      },
      ['.overlay1', '.overlay2'],
    );
  }

  loadHiddenFieldsScript() {
    // URL for the hidden fields script, dependent on MktoForms2
    const hiddenFieldsScriptUrl = 'https://saferworld.3eco.com/rs/026-BZE-703/images/mkto-forms.js';

    if (this.scriptLoaded && !document.querySelector(`script[src="${hiddenFieldsScriptUrl}"]`)) {
      const script = document.createElement('script');
      script.src = hiddenFieldsScriptUrl;
      document.body.appendChild(script);
    }
  }

  render() {
    const iconRows = JSON.parse(this.iconRows);
    //console.log('data', iconRows);
    return (
      <div id="cta-form-block">
        <div
          class={`${this.backgroundColor} ${this.textColor} cta-form-section ${this.paddingBottom} ${this.paddingTop}`}
          style={{ backgroundImage: `url(${this.backgroundImage})` }}
        >
          <div class={`cta-form-wrapper ${iconRows.length === 0 && 'wide'}`}>
            <div class={`overlay1`}></div>
            {this.supertitle && <p>{this.supertitle}</p>}
            {this.mainTitle && <h3 class={`fs-4 mb-32px font-semibold`}>{this.mainTitle}</h3>}
            {this.subtitle && <h4 class={`form-subtitle`}>{this.subtitle}</h4>}
            {this.scriptLoaded && <form id={`mktoForm_${this.formId}`} class={`cta-form text-white`}></form>}
            {iconRows.length > 0 && <div class={`cta-form-svg ${this.subtitle ? 'hide' : ''}`}></div>}
          </div>

          {iconRows.length > 0 && (
            <div class={`form-icon-wrapper`}>
              <div class={`overlay2`}></div>
              {iconRows.length > 0 &&
                iconRows &&
                iconRows.map(row => (
                  <div class={`flex gap-20px  items-center justify-start`}>
                    {/* <div class=" max-w-xs">{row.imageUrl && <image-block imageUrl={row.imageUrl} imageAlt={row.imageAlt} imageClass=" max-w-xs"></image-block>}</div> */}
                    {/* {row.imageUrl && <div class={`max-w-xs h-32px w-32px bg-white`} style={{ maskImage: `url(${row.imageUrl})`, maskSize: 'cover', maskPosition: 'center' }}></div>} */}
                    {(row.imageUrl && row.imageUrl.endsWith('.svg')) || row.imageUrl.endsWith('.png') ? (
                      <div class={`form-icon`} style={{ maskImage: `url(${row.imageUrl})`, maskSize: '100%', maskPosition: 'center' }}></div>
                    ) : row.imageUrl.endsWith('.jpg') ? (
                      // Render different element for .jpg
                      <image-block imageUrl={row.imageUrl} imageAlt={row.imageAlt} imageClass=" max-w-xs icon"></image-block>
                    ) : null}
                    <p class={`text-white fs-1 mb-0 font-normal`}>{row.title}</p>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}
